import React, {useContext} from 'react'
import styled, {ThemeContext} from 'styled-components'
import { Text } from 'rebass'


const Wrapper = styled.div`
  text-align: center;
  img{
    margin: 0 auto;
  }
`


export default function NoArtwork () {
  const theme = useContext(ThemeContext)
  return (
    <Wrapper>
      <img src="/images/collection/noNFT.png" alt=""/>
      <Text fontSize={16} color={theme.text7} fontFamily={'Roboto-Bold'}>There is no NFT on sale</Text>
    </Wrapper>
  )
}